import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from './interactors';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { CameraPath } from '../mdl/geo/CameraPath';
import { Util } from '../utils/Util';
import { RoomElementSnapping } from './RoomElementSnapping';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
export class ChangePolygonPoints extends AbstractInteractorTool {
    constructor(pRoomManager, pPickPlanePos) {
        super(pRoomManager, pPickPlanePos);
        this.mCommand = null;
        this.mLengthFeedback = null;
        this.mOldPickPlane = undefined;
        this.mPointsBkp = [];
    }
    initialize(pMode, pPointIndex, pRoomElement, poldPickPlane) {
        this.mEditMode = pMode;
        this.mPointIndex = pPointIndex;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, pRoomElement);
        this.mLinePoints = [];
        this.mInitialPointMove = true;
        this.mOldPickPlane = poldPickPlane;
        this.mPointsBkp = this.mRoomElement.Params.ElementPoints.slice();
        this.mRoomElement.setToolRunning(true);
        this.mRoomElement.setTransformStatus("Transform");
        if (this.mRoomElement.type === "CameraPath") {
            const tREgeo = this.mRoomElement.geometry;
            if (tREgeo != null) {
                tREgeo.computeCamPathData(false);
            }
        }
        if (this.mRoomElement.GridRE_REF != null) {
            this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
            this.mRESnapping.prepareSnapping(this.mRoomElement.GridRE_REF);
        }
        this.mRoomElement.updateGeometry(false, false);
        this.mRoomManager.TransformShape();
        //this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomElement.setMeshVisibility(1);
        this.mRoomManager.endInteraction();
        super.stop();
    }
    handlePointerUp(pEvent, pState) {
        this.finish();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = pPos;
        this.mCurrentPos = pPos;
        let tPoints = new Array();
        switch (this.mRoomElement.type) {
            case "Line":
                let tgeoLine = this.mRoomElement.geometry;
                tPoints = tgeoLine.getPoints();
                break;
            case "Spline":
                let tgeoSpline = this.mRoomElement.geometry;
                tPoints = tgeoSpline.getPoints();
                break;
            case "Road":
                let tgeoRoad = this.mRoomElement.geometry;
                tPoints = tgeoRoad.getPoints();
                break;
            case "Hedge":
                let tgeoHedge = this.mRoomElement.geometry;
                tPoints = tgeoHedge.getPoints();
                break;
            case "Fence":
                let tgeoFence = this.mRoomElement.geometry;
                tPoints = tgeoFence.getPoints();
                break;
            case "Rectangle":
                let tgeoRect = this.mRoomElement.geometry;
                tPoints = tgeoRect.getPoints();
                break;
            case "CameraPath":
                let tgeoCamPath = this.mRoomElement.geometry;
                tPoints = tgeoCamPath.getPoints();
                break;
            default:
                break;
        }
        this.mInitialLineLength = 0;
        if (this.mPointIndex > 0) {
            if (this.mPointIndex === tPoints.length) {
                this.mInitialLineLength = Vector3.Distance(tPoints[this.mPointIndex - 1], tPoints[0]);
            }
            else {
                this.mInitialLineLength = Vector3.Distance(tPoints[this.mPointIndex - 1], tPoints[this.mPointIndex]);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updatePointerPosition(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        switch (this.mRoomElement.type) {
            case "Line":
                if (this.mRoomElement.GridRE_REF != null) {
                    this.updatePointerPosition_Line_Grid(pPos);
                }
                else {
                    this.updatePointerPosition_Line(pPos);
                }
                break;
            case "Spline":
                this.updatePointerPosition_Spline(pPos);
                break;
            case "Road":
                this.updatePointerPosition_Road(pPos);
                break;
            case "Rectangle":
                this.updatePointerPosition_Rectangle(pPos);
                break;
            case "Hedge":
                this.updatePointerPosition_Hedge(pPos);
                break;
            case "Fence":
                this.updatePointerPosition_Fence(pPos);
                break;
            case "CameraPath":
                if (this.mEditMode === ChangePolygonPoints.Mode.Delete) {
                    this.updatePointerPosition_CameraPath(pPos);
                }
                if (this.mEditMode === ChangePolygonPoints.Mode.changeHeight) {
                    if (this.mPointIndex !== -999) {
                        this.changePointHeight_CameraPath(pPos);
                    }
                    else {
                        this.changePointHeight_CameraTarget(pPos);
                    }
                }
                break;
            default:
                break;
        }
    }
    finish() {
        if (this.mOldPickPlane !== undefined) {
            this.mRoomElement.setPickPlane(this.mOldPickPlane);
        }
        switch (this.mRoomElement.type) {
            case "Line":
                this.finish_Line();
                break;
            case "Spline":
                this.finish_Spline();
                break;
            case "Road":
                this.finish_Road();
                break;
            case "Rectangle":
                this.finish_Rectangle();
                break;
            case "Hedge":
                this.finish_Hedge();
                break;
            case "Fence":
                this.finish_Fence();
                break;
            case "CameraPath":
                this.finish_CameraPath();
                break;
            default:
                break;
        }
    }
    /*
    protected prepareSnapping(): void
    {
        super.prepareSnapping();
        if (this.mMode !== MoveCirlce.Mode.MoveCirlce) {
            this.mCirlceSnapping.prepareSnapping(this.mCirlce, this.mMode === MoveCirlce.Mode.MoveStart ?
                mdl.CirlceEnding.End : mdl.CirlceEnding.Start);
        }
    }
    */
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false, true);
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback.showInteractors(false, true);
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    updatePointerPosition_Line(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry();
        }
        if (this.mRoomManager.ShapeKeepLineLength) {
            if (this.mPointIndex === 0) {
                tPoints[this.mPointIndex] = tpointsPos;
            }
            else {
                let tDir = tpointsPos.subtract(tPoints[this.mPointIndex - 1]).normalize();
                tPoints[this.mPointIndex] = tPoints[this.mPointIndex - 1].add(tDir.scale(this.mInitialLineLength));
            }
        }
        else {
            tPoints[this.mPointIndex] = tpointsPos;
        }
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Line_Grid(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add ||
            this.mRoomElement.GridRE_REF == null) {
            return;
        }
        let tPos = pPos;
        if (this.mRESnapping != null) {
            tPos = this.mRESnapping.snap(pPos, this.mView);
        }
        if (this.mRoomElement.GridRE_REF != null) {
            tPos = Vector3.TransformCoordinates(tPos, this.mRoomElement.GridRE_REF.transformInverted);
        }
        this.mCurrentPos = tPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints().slice();
        this.mLinePoints = tPoints;
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry();
        }
        tPoints[this.mPointIndex] = tPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Spline(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry();
        }
        if (this.mRoomManager.ShapeKeepLineLength) {
            if (this.mPointIndex === 0) {
                tPoints[this.mPointIndex] = tpointsPos;
            }
            else {
                let tDir = tpointsPos.subtract(tPoints[this.mPointIndex - 1]).normalize();
                tPoints[this.mPointIndex] = tPoints[this.mPointIndex - 1].add(tDir.scale(this.mInitialLineLength));
            }
        }
        else {
            tPoints[this.mPointIndex] = tpointsPos;
        }
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Road(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry(false);
        }
        tPoints[this.mPointIndex] = tpointsPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Hedge(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry(false);
        }
        tPoints[this.mPointIndex] = tpointsPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Fence(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry(false);
        }
        tPoints[this.mPointIndex] = tpointsPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_CameraPath(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry(false);
        }
        tPoints[this.mPointIndex] = tpointsPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        tREgeo.computeCamPathData();
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    changePointHeight_CameraPath(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transform);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            // tREgeo.setPoints(this.mLinePoints);
            // this.mRoomElement.updateGeometry(false);
        }
        tPoints[this.mPointIndex].y = tpointsPos.y - this.mPointsBkp[this.mPointIndex].y;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        tREgeo.computeCamPathData();
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    changePointHeight_CameraTarget(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        const tREgeo = this.mRoomElement.geometry;
        const tcustomTarget = tREgeo.getCurrCustomTarget();
        if (tcustomTarget == null) {
            return;
        }
        // let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transform);
        let tpointsPos = pPos;
        // if (this.mInitialPointMove) {
        //     this.mInitialPointMove = false;
        //     tREgeo.setPoints(this.mLinePoints);
        //     this.mRoomElement.updateGeometry(false);
        // }
        tcustomTarget.target.y = tpointsPos.y;
        tREgeo.computeCamPathData();
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    updatePointerPosition_Rectangle(pPos) {
        if (this.mEditMode === ChangePolygonPoints.Mode.Add)
            return;
        this.mCurrentPos = pPos;
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        this.mLinePoints = tPoints;
        let tpointsPos = Vector3.TransformCoordinates(pPos, this.mRoomElement.transformInverted);
        if (this.mInitialPointMove) {
            this.mInitialPointMove = false;
            tREgeo.setPoints(this.mLinePoints);
            this.mRoomElement.updateGeometry();
        }
        tPoints[this.mPointIndex] = tpointsPos;
        this.mLinePoints = tPoints;
        tREgeo.setPoints(tPoints);
        this.mRoomElement.updateGeometry(false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish_Line() {
        if (this.mRoomElement.GridRE_REF != null) {
            this.finish_Line_Grid();
            return;
        }
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                else {
                    // center polygon points
                    let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
                    let tREgeo = this.mRoomElement.geometry;
                    let tPoints = tREgeo.getPoints();
                    let tpolyCenter = Util.getCenterofPolygon(tPoints);
                    let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
                    let tcurrPos = this.mRoomElement.position.clone();
                    tPoints = Util.centerPolygon(tPoints);
                    tREgeo.setPoints(tPoints);
                    this.mRoomElement.setTransformStatus("");
                    this.mRoomElement.updateGeometry(true, false);
                    this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
                }
                break;
            default:
                break;
        }
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
    finish_Line_Grid() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                else {
                    this.mRoomElement.setTransformStatus("");
                    this.mRoomElement.updateGeometry(true, false);
                }
                break;
            default:
                break;
        }
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
        }
    }
    finish_Spline() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                else {
                    // center polygon points
                    let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
                    let tREgeo = this.mRoomElement.geometry;
                    let tPoints = tREgeo.getPoints();
                    let tpolyCenter = Util.getCenterofPolygon(tPoints);
                    let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
                    let tcurrPos = this.mRoomElement.position.clone();
                    tPoints = Util.centerPolygon(tPoints);
                    tREgeo.setPoints(tPoints);
                    this.mRoomElement.setTransformStatus("");
                    this.mRoomElement.updateGeometry(true, false);
                    this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
                }
                break;
            default:
                break;
        }
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
    finish_Road() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                break;
            default:
                break;
        }
        // center polygon points
        let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        let tpolyCenter = Util.getCenterofPolygon(tPoints);
        let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
        let tcurrPos = this.mRoomElement.position.clone();
        tPoints = Util.centerPolygon(tPoints);
        tREgeo.setPoints(tPoints);
        this.mRoomElement.setTransformStatus("");
        this.mRoomElement.updateGeometry(true, false);
        this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
    finish_Hedge() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                break;
            default:
                break;
        }
        // center polygon points
        let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        let tpolyCenter = Util.getCenterofPolygon(tPoints);
        let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
        let tcurrPos = this.mRoomElement.position.clone();
        tPoints = Util.centerPolygon(tPoints);
        tREgeo.setPoints(tPoints);
        this.mRoomElement.setTransformStatus("");
        this.mRoomElement.updateGeometry(true, false);
        this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
    finish_Fence() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                break;
            default:
                break;
        }
        // center polygon points
        let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        let tpolyCenter = Util.getCenterofPolygon(tPoints);
        let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
        let tcurrPos = this.mRoomElement.position.clone();
        tPoints = Util.centerPolygon(tPoints);
        tREgeo.setPoints(tPoints);
        this.mRoomElement.setTransformStatus("");
        this.mRoomElement.updateGeometry(true, false);
        this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
    finish_CameraPath() {
        switch (this.mEditMode) {
            case ChangePolygonPoints.Mode.Add:
                this.mRoomElement.addPoint(this.mPointIndex);
                break;
            case ChangePolygonPoints.Mode.Delete:
                if (Util.vectorEquals3(this.mStartPos, this.mCurrentPos)) {
                    this.mRoomElement.deletePoint(this.mPointIndex);
                }
                break;
            default:
                break;
        }
        // center polygon points
        let tWM = this.mRoomElement.node.getWorldMatrix().getRotationMatrix();
        let tREgeo = this.mRoomElement.geometry;
        let tPoints = tREgeo.getPoints();
        let tpolyCenter = Util.getCenterofPolygon(tPoints);
        let tCenter_rot = Vector3.TransformCoordinates(tpolyCenter, tWM);
        let tcurrPos = this.mRoomElement.position.clone();
        tPoints = Util.centerPolygon(tPoints);
        tREgeo.setPoints(tPoints);
        this.mRoomElement.setTransformStatus("");
        this.mRoomElement.setPosition(tcurrPos.add(tCenter_rot));
        tREgeo.computeCamPathData(CameraPath.splitPath);
        this.mRoomElement.updateGeometry(true, false);
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mRoomManager._addCamData();
                this.mCommand = null;
                this.stop();
            });
    }
    finish_Rectangle() {
        this.mRoomElement.setToolRunning(false);
        this.mRoomManager.setTransformationDepth(0);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mCommand !== null)
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
    }
}
//add nested types
(function (ChangePolygonPoints) {
    let Mode;
    (function (Mode) {
        Mode[Mode["Add"] = 0] = "Add";
        Mode[Mode["Delete"] = 1] = "Delete";
        Mode[Mode["changeHeight"] = 2] = "changeHeight";
    })(Mode = ChangePolygonPoints.Mode || (ChangePolygonPoints.Mode = {}));
})(ChangePolygonPoints || (ChangePolygonPoints = {}));
